import {
  exportNameTargetKey,
  type ExportArtifactKind,
} from "@constructionautomation/backend/convex/lib/exportArtifactNames";

import { buildDefaultExportName } from "@/lib/export-filenames";

const TARGET_LABELS: Record<string, string> = {
  submittal_log: "Submittal Log",
  "tracker:lead_time": "Lead Time Log",
  "tracker:warranty": "Warranty Log",
  "tracker:attic_stock": "Attic Stock Log",
  trackers: "Trackers",
  takeoff: "Takeoff",
  field_report: "Field Report",
  revision_report: "Revision Report",
  annotated_plans: "Annotated Plans",
};

// SpecPilot names leave out the job: a project normally has one submittal log.
const TARGETS_WITHOUT_JOB = new Set(["submittal_log", "trackers"]);

function labelFor(targetKey: string) {
  if (targetKey.startsWith("tracker:custom:")) {
    return `${targetKey.slice("tracker:custom:".length) || "Custom Tracker"} Log`;
  }
  return TARGET_LABELS[targetKey] ?? "Export";
}

/** The deliverable key and default name for an export, e.g. "Baker Mackenzie Lead Time Log". */
export function exportTarget(
  exportKind: ExportArtifactKind,
  options: object,
  names: { projectName: string | null | undefined; jobName?: string | null }
) {
  const key = exportNameTargetKey(exportKind, options);
  const includeJob = !TARGETS_WITHOUT_JOB.has(key) && !key.startsWith("tracker:");
  return {
    key,
    defaultName: buildDefaultExportName({
      projectName: names.projectName,
      jobName: includeJob ? names.jobName : undefined,
      label: labelFor(key),
    }),
  };
}
